<template>
    <div class="row">
        <div v-if="label && Array.isArray(label) && label[0]" :class="aspect.leftColumnWrapperClass">
            <label>{{label[0]}}</label>
        </div>
        <div :class="formElementColumns">
            <div :class="aspect.formFieldWrapperClass">
                <select v-if="value" v-model="value.region" @change="regionChanged" :class="aspect.formFieldClass" :disabled="disabled || regions.length == 0">
                    <option disabled="disabled" :value="null">{{translations.pickRegion}}</option>
                    <option  v-for="region in regions" :key="region.key" :value="region.id">{{region.name}}</option>
                </select>
            </div>
        </div>
        <div v-if="label && Array.isArray(label) && label[1]" :class="aspect.leftColumnWrapperClass">
            <label>{{label[1]}}</label>
        </div>
        <div :class="formElementColumns">
            <div :class="aspect.formFieldWrapperClass">
                <select v-if="value" v-model="value.province"  @change="provinceChanged" :disabled="disabled || provinces.length == 0" :class="aspect.formFieldClass">
                    <option disabled="disabled" :value="null">{{translations.pickProvince}}</option>
                    <option  v-for="province in provinces" :key="province.key" :value="province.id">{{province.name}}</option>
                </select>
            </div>
        </div>
        <div v-if="label && Array.isArray(label) && label[2]" :class="aspect.leftColumnWrapperClass">
            <label>{{label[2]}}</label>
        </div>
        <div :class="formElementColumns">
            <div :class="aspect.formFieldWrapperClass">
                <select v-if="value" v-model="value.city" :class="aspect.formFieldClass" :disabled="disabled || cities.length == 0">
                    <option disabled="disabled" :value="null">{{translations.pickCity}}</option>
                    <option  v-for="city in cities" :key="city.key" :value="city.id">{{city.name}}</option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
  import axios from 'axios';
    export default {
        name: "form-element-location-italy",
        props: {
            value:null,
            placeholder: null,
            validations: {type: Array, default: function(){ return []; }},
            translations: {type: Object, default: function(){ return {}; }},
            location: {type: Object, default: function(){ return {}; }},
            aspect: {type: Object, default: function(){ return {}; }},
            formElementColumns: null,
            label: {type: Array, required: false},
            disabled: {type: Boolean},
            refreshIndex: {type: Number, default: 0}
        },
        data() {
            return {
                countries: [],
                regions: [],
                provinces: [],
                cities: [],
            }
        },
        created(){
            this.createdMethod()
        },
        watch: {
            refreshIndex: {
                deep: true,
                handler(){
                    this.createdMethod()
                    this.mountedMethod()
                }
            }
        },
        mounted(){
            this.mountedMethod()
        },
        methods: {
            createdMethod(){
                if(this.value == null){
                    this.$emit("input", {region: null, province: null, city: null});
                }
            },
            mountedMethod(){
                axios.post(this.location.regions+"?ajax_action=world_regions&country=100").then((r)=>{
                    this.regions = r.data;
                    if(this.value.region){
                        axios.post(this.location.provinces+"?ajax_action=world_provinces&region="+this.value.region).then((r)=>{
                            this.provinces = r.data;
                            if(this.value.city){
                                axios.post(this.location.cities+"?ajax_action=world_cities&province="+this.value.province).then((r)=>{
                                    this.cities = r.data;
                                });
                            }
                        });
                    };
                });
            },
            regionChanged(){
                axios.post(this.location.provinces+"?ajax_action=world_provinces&region="+this.value.region).then((r)=>{
                    this.provinces = r.data;
                    this.cities = [];
                    this.$emit("input", {country: 100, region: this.value.region, province: null, city: null});
                });
            },
            provinceChanged(){
                axios.post(this.location.cities+"?ajax_action=world_cities&province="+this.value.province).then((r)=>{
                    this.cities = r.data;
                    this.$emit("input", {country: 100, region: this.value.region, province: this.value.province, city: null});
                });
            },
            async evaluateValidationCondition(condition){
                if(condition.type == "fields-required" ){
                    for(var i=0; i < condition.fields.length; i++){
                        if(!(this.value && this.value[condition.fields[i]])){
                            return this.translations.requiredWarning;
                        }
                    }
                }
                return null;
            }
        }
    }
</script>
